import { computed } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { auth0 } from '@/auth0'
import { graphql } from '@/gql'
import { request } from '@/graphql-client'

export function useCurrentUser() {
  const queryKey = computed(() => ['current-user', auth0.user.value?.sub])
  const query = useQuery({
    queryKey,
    enabled: computed(() => !auth0.isLoading.value && auth0.isAuthenticated.value),
    staleTime: 60_000,
    queryFn: () =>
      request(
        graphql(`
          query CurrentUser {
            currentUser {
              customerIds
              metadata {
                productResearchOptIn
              }
            }
          }
        `)
      )
  })

  return { ...query, queryKey, currentUser: computed(() => query.data.value?.currentUser) }
}
